"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var watch_1 = require("./watch");
var server_1 = require("./server");
var isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
var Proxy = /** @class */ (function () {
    function Proxy(wrappedObject, watchFilter) {
        var _this = this;
        this.usedChannels = [];
        this.trace = function (name, message) {
            var params = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                params[_i - 2] = arguments[_i];
            }
            if (_this.watchFilter(name)) {
                _this.log.apply(_this, [name, message].concat(params));
                _this.wrappedObject.trace();
            }
        };
        this.list = function (match) {
            var channels = _this.usedChannels.slice();
            if (match) {
                channels = channels.filter(function (name) { return watch_1.matchChannel(name, match); });
            }
            return channels;
        };
        this.alert = function (name, message, tags, data) {
            _this.warn(name, message, tags, data);
            if (server_1.isSSR()) {
                return;
            }
            if (!isPlainObject_1.default(data)) {
                console.warn('[ddt] alert data is not a plain object', data);
                return;
            }
            var payload = {
                error: message,
                data: __assign({ browser: {
                        userAgent: navigator && navigator.userAgent,
                        location: location && location.href,
                        referrer: document && document.referrer,
                    }, app: (window && window['__APP_INFO__']) || 'unknown' }, data),
                tags: tags,
            };
            var xhr = new XMLHttpRequest();
            xhr.open('POST', 'https://www.deviantart.com/_napi/da-comments/shared_api/util/ddt');
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.send(JSON.stringify({ payload: payload }));
        };
        this.createLogger = function (channel) {
            var channelCurry = function (callback) {
                return function (message) {
                    var params = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        params[_i - 1] = arguments[_i];
                    }
                    params.unshift(channel, message);
                    return callback.apply(_this, params);
                };
            };
            return {
                log: channelCurry(_this.log),
                info: channelCurry(_this.info),
                warn: channelCurry(_this.warn),
                error: channelCurry(_this.error),
                trace: channelCurry(_this.trace),
            };
        };
        this.wrappedObject = wrappedObject;
        this.watchFilter = watchFilter;
        this.log = this.wrap('log');
        this.info = this.wrap('info');
        this.warn = this.wrap('warn');
        this.error = this.wrap('error');
    }
    Proxy.prototype.wrap = function (type) {
        var _this = this;
        if (!(type in this.wrappedObject)) {
            this.wrappedObject.warn('[ddt] cannot proxy this method, it is not defined in console', type);
        }
        var proxied = this.wrappedObject[type];
        return function (name, message) {
            var params = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                params[_i - 2] = arguments[_i];
            }
            if (_this.usedChannels.indexOf(name) === -1) {
                _this.usedChannels.push(name);
            }
            if (!_this.watchFilter(name)) {
                return;
            }
            // reformat the message to include the package name
            params.unshift("[" + name + "] " + message);
            return proxied.apply(_this.wrappedObject, params);
        };
    };
    return Proxy;
}());
exports.Proxy = Proxy;
//# sourceMappingURL=proxy.js.map